import React from 'react';
import { SDG_IMAGES } from '../../../../constants/datas';
import AvatarImage from '../../../../ui/AvatarImage';
import BountyDescription from '../../../bounties/BountyDescription';
import { EarthIcon, FistIcon, SunIcon, WaterIcon } from '../../../../assets/icons/ProgressBarIcons';
import PdfHeaderComponent from './PdfHeaderComponent';
import { dateAndYear } from '../../../../helpers/addTime';


const coreIcons = {
  Earth: <EarthIcon key={'earth-icon'} color="" />,
  Energy: <SunIcon key="sun-icon" color="" />,
  Social: <FistIcon key={'fist-icon'} color="" />,
  Water: <WaterIcon key={'water-icon'} color="" />,
};

const IntroductionPageComponent = ({ activities = [], overallData = null,projectData }) => {
  const firstActivity = activities[0];
console.log(projectData,overallData,activities,"solve first this")
  return (
    <div className="pdf-section pdf-page-break" style={{ paddingTop: '20px', paddingBottom: '40px', paddingLeft: '20px', paddingRight: '20px' }}>
      <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
      <h2 className="text-2xl font-semibold text-textPrimary mb-3">Introduction</h2>
      
      {/* About Section */}
      <div className="mb-3">
        <h3 className="font-semibold text-textPrimary text-lg mb-1">About</h3>
        <p className="text-textPrimary ">
          Creating a locally owned water network that increases water access and security while creating green jobs and incentivising harvesting and recycling water
        </p>
      </div>

      {/* Overview Section */}
      <div className="mb-6">
        <h3 className="font-semibold text-textPrimary mb-3">Overview</h3>
        <div className="grid grid-cols-2">
        <div className="space-y-2 text-textPrimary pr-10">
  <div className="flex items-baseline">
    <span className="mr-2">•</span>
    <span>Start Date- {dateAndYear(overallData?.firstBountyStartDate)}</span>
  </div>
  <div className="flex items-baseline">
    <span className="mr-2">•</span>
    <span>End Date (validation date of last bounty)- {dateAndYear(overallData?.latestBountyValidationDate)}</span>
  </div>
  <div className="flex items-baseline">
    <span className="mr-2">•</span>
    <span>Backed By- {overallData?.organisation?.name}</span>
  </div>
  <div className="flex items-baseline">
    <span className="mr-2">•</span>
    <div>
      <span>Impact Cores- </span>
      <div className='flex items-center gap-3 mt-1'>
        {projectData?.impactMetrics?.cores?.map((core) => 
          <span key={core} className='flex items-center gap-1'>
            <span style={{display: 'inline-flex', alignItems: 'center'}}>{coreIcons[core]}</span>
            <span style={{verticalAlign: 'middle', lineHeight: '1'}}>{core}</span>
          </span>
        )}
      </div>
    </div>
  </div>
  <div className="flex items-baseline">
    <span className="mr-2">•</span>
    <div>
      <span>SDGs- </span>
      <div className='grid grid-cols-7 gap-1 mt-2'>
        {projectData?.impactMetrics?.SDGs?.map((sdg, index) => (
          <img key={sdg + index + Math.random()} className="w-8 h-8" src={SDG_IMAGES[sdg]} alt="" />
        ))}
      </div>
    </div>
  </div>
        </div>


       
  <div className="border-l border-gray-300 text-textPrimary pl-10 space-y-2">
    <div className="flex items-baseline">
      <span className="mr-2">•</span>
      <span>Participants till date- {overallData?.uniqueBountyAcceptorCount}</span>
    </div>
    <div className="flex items-baseline">
      <span className="mr-2">•</span>
      <span>Activities Completed- {overallData?.completedBountyCount}</span>
    </div>
    <div className="flex items-baseline">
      <span className="mr-2">•</span>
      <span>Funds Deployed- ${overallData?.totalFundsDeployedUSD}</span>
    </div>
    <div className="flex items-baseline">
      <span className="mr-2">•</span>
      <span>Impact Certificates Issued- {overallData?.totalImpactCertificatesIssued}</span>
    </div>
  </div>
        </div>
      </div>

    </div>
  );
};

export default IntroductionPageComponent;
